import Certifications from './Certifications';

export default Certifications;
